<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!-- 搜索 -->
      <div>
        <el-select
          v-model="projectId"
          placeholder="请选择"
          style="width: 250px"
          size="mini"
          filterable
        >
          <el-option
            v-for="item in projects"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
        <span style="margin-right: 10px"></span>
        <el-date-picker
          v-model="rqScope"
          size="mini"
          type="daterange"
          value-format="yyyy-MM-dd"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
        >
        </el-date-picker>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="initRep"
          style="margin-left: 10px"
          size="mini"
        >
          搜索
        </el-button>
      </div>
      <!-- 右边工具 -->
      <div>
        <el-button
          type="success"
          @click="downloadExcel"
          style="margin-left: 10px"
          size="mini"
        >
          <i class="fa fa-level-down" aria-hidden="true"></i>
          导出数据</el-button
        >

        <el-button
          type="success"
          icon="el-icon-refresh"
          @click="initRep"
          size="mini"
          >刷新</el-button
        >
      </div>
    </div>
    <div style="margin-top: 20px">
      <el-table
        :data="reportData"
        border
        stripe
        height="700"
        size="mini"
        id="mytable"
        @cell-click="cellClick"
        :header-cell-style="{
          background: '#eef1f6',
          color: '#606266',
          borderColor: 'white',
        }"
        style="width: 100%"
      >
        <el-table-column prop="bm" label="项目编码" align="center" width="100">
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="center"
          width="200"
        >
        </el-table-column>
        <el-table-column prop="rq" label="日期" align="center" width="120">
        </el-table-column>
        <el-table-column
          label="项目合同金额"
          align="center"
          width="140"
          sortable
          :sort-method="
            (a, b) => {
              return a.incomexj - b.incomexj;
            }
          "
        >
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.incomexj) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="项目回款金额"
          align="center"
          sortable
          :sort-method="
            (a, b) => {
              return a.backmoneyxj - b.backmoneyxj;
            }
          "
          width="140"
        >
          <template slot-scope="scope">
            <span>{{ moneyNumber(scope.row.backmoneyxj) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="项目成本及费用"
          align="center"
          v-if="show_buy_cost"
        >
          <el-table-column
            label="采购成本支出"
            align="center"
            sortable
            :sort-method="
              (a, b) => {
                return a.bmxj - b.bmxj;
              }
            "
            width="140"
          >
            <template slot-scope="scope">
              <span>{{ moneyNumber(scope.row.bmxj) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="费用" align="center">
            <el-table-column
              label="人工费"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost1 - b.cost1;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost1) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="公关招待费"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost2 - b.cost2;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost2) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="差旅费"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost3 - b.cost3;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost3) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="交通费"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost4 - b.cost4;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost4) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="中标服务费"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost5 - b.cost5;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost5) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="车辆使用费"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost6 - b.cost6;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost6) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="办公费"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost7 - b.cost7;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost7) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="运输费"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost8 - b.cost8;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost8) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="广告宣传费"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost9 - b.cost9;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost9) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="邮电通讯费"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost10 - b.cost10;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost10) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="咨询会务费"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost11 - b.cost11;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost11) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="维修费"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost12 - b.cost12;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost12) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="奖金提成"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost13 - b.cost13;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost13) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="业务拓展费"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost15 - b.cost15;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost15) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="其他费用"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost14 - b.cost14;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost14) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="借款"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.cost18 - b.cost18;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.cost18) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="小计"
              align="center"
              sortable
              :sort-method="
                (a, b) => {
                  return a.costxj - b.costxj;
                }
              "
              width="130"
            >
              <template slot-scope="scope">
                <span>{{ moneyNumber(scope.row.costxj) }}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="合计"
            align="center"
            sortable
            :sort-method="
              (a, b) => {
                return a.hj - b.hj;
              }
            "
            width="130"
          >
            <template slot-scope="scope">
              <span>{{ moneyNumber(scope.row.hj) }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="税金" align="center" v-if="show_rate">
          <el-table-column
            label="增值税及附加"
            align="center"
            sortable
            :sort-method="
              (a, b) => {
                return a.rate1 - b.rate1;
              }
            "
            width="140"
          >
            <template slot-scope="scope">
              <span>{{ moneyNumber(scope.row.rate1) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="企业所得税"
            align="center"
            sortable
            :sort-method="
              (a, b) => {
                return a.rate2 - b.rate2;
              }
            "
            width="130"
          >
            <template slot-scope="scope">
              <span>{{ moneyNumber(scope.row.rate2) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="印花税"
            align="center"
            sortable
            :sort-method="
              (a, b) => {
                return a.rate3 - b.rate3;
              }
            "
            width="130"
          >
            <template slot-scope="scope">
              <span>{{ moneyNumber(scope.row.rate3) }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="保证金" align="center">
          <el-table-column
            label="投标保证金"
            align="center"
            sortable
            :sort-method="
              (a, b) => {
                return a.money1 - b.money1;
              }
            "
            width="130"
          >
            <template slot-scope="scope">
              <span>{{ moneyNumber(scope.row.money1) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="履约保证金"
            align="center"
            sortable
            :sort-method="
              (a, b) => {
                return a.money2 - b.money2;
              }
            "
            width="130"
          >
            <template slot-scope="scope">
              <span>{{ moneyNumber(scope.row.money2) }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="备注" align="center" width="200">
          <template scope="scope">
            <el-input
              style="width: 198px; height: 12px"
              size="mini"
              v-model="scope.row.demo"
              v-if="scope.row.demoFlag"
              @blur="loseFcous(scope.$index, scope.row)"
              clearable
            >
            </el-input>
            <span style="margin-left: 10px" v-else>{{ scope.row.demo }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
  name: "ProjRep",
  data() {
    return {
      title: "",
      // demoFlag: false,  // 控制demo字段显示span标签还是显示input框
      reportData: [], // 存放查询结果
      projectName: "",
      projectId: null,
      rqScope: "",
      projects: [], //项目id-项目名称下拉框
      show_buy_cost: true,
      show_rate: true,
      show_hk: true,
      show_income: true,
      input_demo: {
        demoId: null,
        demo: "",
      },
      chanceTypes: [],
      chanceType: "",
    };
  },
  mounted() {
    // this.getRouterData()
    this.getRouterData1();
    this.initRep();
    this.initDim();
  },
  methods: {
    chanceTypeName(code) {
      let item = this.chanceTypes.find((item) => item.code == code);
      return item ? item.name : "";
    },
    moneyNumber(val) {
      // return val.toLocaleString("zh-Hans-CN",{style:"currency",currency:"CNY"})
      // return val.toLocaleString()

      if (val == 0) {
        return "";
      } else {
        return val.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    },
    getRouterData() {
      // 在自身页面替换
      if (this.$route.params.projectId) {
        this.projectId = this.$route.params.projectId;
      }
      // alert(this.projectId)
    },
    getRouterData1() {
      // 在新窗口打开明细报表
      if (this.$route.query.projectId) {
        this.projectId = this.$route.query.projectId;
      }
      // alert(this.projectId)
    },
    loseFcous(index, row) {
      row.demoFlag = false;
      this.input_demo.demoId = row.demoId;
      this.input_demo.demo = row.demo;
      // alert(index)
      // alert(JSON.stringify(row))
      this.postRequest("/project/demo_update", this.input_demo).then((resp) => {
        if (resp) {
          //更新密码成功后退出登录
          this.input_demo.demoId = null;
          this.input_demo.demo = "";
          this.$message("修改备注数据成功！");
        }
      });
    },
    cellClick(row, column) {
      row.demoFlag = true;
    },
    initRep() {
      this.loading = true;
      let url = "/project/report_detail?projectId=" + this.projectId;
      if (this.chanceType) {
        url += "&chanceType=" + this.chanceType;
      }
      if (this.rqScope) {
        url += "&rqScope=" + this.rqScope;
      }
      this.getRequest(url).then((resp) => {
        if (resp) {
          console.log(resp.result);
          this.reportData = resp.result;
        }
      });
    },
    initDim() {
      this.postRequest("/dim/dim_table_char/chance_type").then((resp) => {
        if (resp) {
          this.chanceTypes = resp.result;
          this.saveDictCache("chanceTypes", resp.result);
        }
      });
      if (!window.sessionStorage.getItem("projects")) {
        this.getRequest("/dim/project?flag=false").then((resp) => {
          if (resp) {
            this.projects = resp.result;
            this.saveDictCache("projects", resp.result);
          }
        });
      } else {
        this.projects = this.dictCache("projects");
      }
    },
    downloadExcel() {
      var wb = XLSX.utils.table_to_book(document.querySelector("#mytable")); //mytable为表格的id名
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], {
            type: "application/octet-stream",
          }),
          "项目明细报表.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    // 表头样式
    // headerStyle(row) {
    // 	let basis = 'background:#7998BE;text-align:center;color:#ffffff'
    // if (row.column.label === '定位') {
    // basis += 'border-left: none;'
    // }
    // if (row.column.label === '价格') {
    // 	basis += 'background:#5A94E8;'
    // }
    // 	return basis;
    // },
    // 单元格样式
    cellStyle(row) {
      let basis = "text-align:center;";
      if (row.column.label === "价格 (金币)" && row.rowIndex % 2 === 1) {
        basis += "background:#E5F0FE;";
      }
      return basis;
    },
  },
  beforeRouteEnter(to, from, next) {
    sessionStorage.removeItem("projects");
    next();
  },
};
</script>

<style>
</style>
